import type { FacilityWorkflowAutomaticSourcePayload } from '@Application/Facilities/Workflows/Actions/facilityWorkflowsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A document the group carries over automatically from the dossier (latest, or latest verified).
 */
class FacilityWorkflowAutomaticSourceView {
	readonly documentTypeId: number;
	readonly verifiedOnly: boolean;

	constructor(payload: FacilityWorkflowAutomaticSourcePayload) {
		this.documentTypeId = payload.documentType.id;
		this.verifiedOnly = payload.verifiedOnly;

		Object.freeze(this);
	}
}

export default FacilityWorkflowAutomaticSourceView;
